import { atom } from "recoil";

export const groupAddModalStore = atom({
	key: "groupAddModalStore",
	default: {
		show: false,
		loaded: true,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
